<template>
  <div class="TotalAmountComponent">
    <label>{{ label }}</label>
    <h2>{{ amount }}{{ props.currency }}{{ props.period }}</h2>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps({
  label: String,
  amount: String,
  currency: String,
  period: String
})

const amount = computed(() => {
  return !props.amount && props.amount !== '0' ? '-- --' : props.amount
})
</script>

<style lang="scss" scoped>
.TotalAmountComponent {
  h2 {
    font-size: $font-size-40;
    font-weight: $font-weight-500;
  }

  label {
    color: $color-neutral;
    font-size: $font-size-20;
  }
}
</style>
